import type { Vector2 } from "three";
import type { MiterType } from "../enum/MiterType";

/**
 * Cross-section coordinates include gap, strength, die form and inversion.
 * The sampled, centred contour includes side mapping and all path segments.
 * Rounding/normal processing use fixed module constants, never per-instance state.
 */
export function profileGeometryKey(
  profile: ReadonlyArray<readonly [number, number]>,
  contour: readonly Vector2[],
  miter: MiterType,
  ccw: boolean,
): string {
  return JSON.stringify([
    profile,
    contour.map((point) => [point.x, point.y]),
    miter,
    ccw,
  ]);
}
